import { render, staticRenderFns } from "./PagamentosHistorico.vue?vue&type=template&id=332303da&scoped=true&"
import script from "./PagamentosHistorico.vue?vue&type=script&lang=js&"
export * from "./PagamentosHistorico.vue?vue&type=script&lang=js&"
import style0 from "./PagamentosHistorico.vue?vue&type=style&index=0&id=332303da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332303da",
  null
  
)

export default component.exports